<template>
  <div>
    <div>
      <div>
        <div class="form-item-label">
          <Input placeholder="自定义标题" size="default" v-model="attrObj.title"/>
        </div>
        <div class="form-item-content">
          <Input v-model="attrObj.desc" type="textarea" :rows="2" placeholder="请输入自定义提示内容"/>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
export default {
  props: {
    attrObj: Object
  },
  data() {
    return {
      code: 0
    };
  },
  created() {},
  //初始化后调用
  mounted: function() {},
  methods: {
    addAttr() {
      this.attrObj.optionList.push({
        optionCode: "code" + this.code++,
        optionContent: ""
      });
    },
    deleteAttr(index) {
      this.attrObj.optionList.splice(index, 1);
    },
    //关闭
    handleClose() {
      let tabItemName = this.$parent.name;
      this.$emit("handleClose", tabItemName);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/customForm/dynamicAttr/textarea.vue